import React, { useState } from "react";
import useInterval from "../../Scripts/useInterval";
import { bigNumAsInt } from "../../Scripts/bigNumAsInt";
import { ethers, BigNumber } from "ethers";
import { useMetamask } from "../../Scripts/UseMetamask";
import { contractAddress } from "../../AppCustomisation/dAPPCustomisation.js";
import Contract from "../../AppCustomisation/mainContractABI.json";
import { SupplyP2 } from "./HeroElements";

function TotalSupply() {
  const [hover, setHover] = useState(false);
  const [totalMinted, setTotalMinted] = useState(0);

  const { account, provider, signer } = useMetamask();

  const handleFetchTotalMinted = async () => {
    const contract = new ethers.Contract(
      contractAddress,
      Contract.abi,
      provider
    );

    try {
      const totalMinted = await contract.totalSupply();
      setTotalMinted(bigNumAsInt(totalMinted));
    } catch (err) {
      console.log(err);
    }
  };

  useInterval(() => {
    handleFetchTotalMinted();
  }, 5000);

  const onHover = () => {
    setHover(!hover);
  };
  return (
    <>
      <SupplyP2>
        {totalMinted}/999
      </SupplyP2>
    </>
  );
}

export default TotalSupply;
